// initial state
const state = {
  all: null,
  error: null,
  formMapping: {}
}

// getters
const getters = {
  allPokemon: state => state.all,
  pokemonError: state => state.error,
  formMapping: state => state.formMapping
}

// actions
const actions = {
  getPokemon ({ commit }, pokemon) {
    commit('setPokemons', pokemon.data)
  },
  setError ({commit}, data) {
    commit('setError', data.data)
  },
  getFormMapping ({ commit }, message) {
    commit('setFormMapping', message.data)
  }
}

// mutations
const mutations = {
  setPokemons (state, products) {
    state.all = products
  },
  setError (state, error) {
    state.error = {error: error, time: Date.now()}
  },
  setFormMapping (state, mapping) {
    state.formMapping = mapping
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
